import { createSlice } from '@reduxjs/toolkit';

const SettlementsSlice = createSlice({
  name: 'SettlementsSlice',
  initialState: {
    isLoading: false,
    getSettlementsData: [],
    isError: null,
    isPDFDownload: false,
    isEmailSending: false,
    isGenerating: false,
    // Async invoice jobs list (RAT-1810) for the Invoice Jobs tab.
    invoiceJobs: [],
    invoiceJobsTotal: 0,
    invoiceJobsLoading: false,
  },
  reducers: {
    /////// Async invoice jobs list (RAT-1810) ////////
    requestGetInvoiceJobs: (state) => {
      return { ...state, invoiceJobsLoading: true };
    },
    responseGetInvoiceJobs: (state, action) => {
      return {
        ...state,
        invoiceJobsLoading: false,
        invoiceJobs: action?.payload?.items || [],
        invoiceJobsTotal: action?.payload?.total || 0,
      };
    },
    failureGetInvoiceJobs: (state, action) => {
      return {
        ...state,
        invoiceJobsLoading: false,
        isError: action?.payload,
      };
    },

    ////////// get Settlements data /////////
    requestGetSettlements: (state) => {
      return { ...state, isLoading: true };
    },
    responseGetSettlements: (state, action) => {
      return {
        ...state,
        isLoading: false,
        getSettlementsData: action.payload,
      };
    },
    failureGetSettlements: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Download Settlements PDF (Merchant Invoice) ////////
    requestDownloadSettlementsPDF: (state) => {
      return { ...state, isPDFDownload: true };
    },
    responseDownloadSettlementsPDF: (state) => {
      return {
        ...state,
        isPDFDownload: false,
      };
    },
    failureDownloadSettlementsPDF: (state, action) => {
      return { ...state, isPDFDownload: false, isError: action?.payload };
    },

    /////// Send Settlements Email ////////
    requestSendSettlementsEmail: (state) => {
      return { ...state, isEmailSending: true };
    },
    responseSendSettlementsEmail: (state) => {
      return {
        ...state,
        isEmailSending: false,
      };
    },
    failureSendSettlementsEmail: (state, action) => {
      return { ...state, isEmailSending: false, isError: action?.payload };
    },

    /////// Settlement Module download PDF ////////
    requestDownloadSettlementPDF: (state) => {
      return { ...state, isPDFDownload: true };
    },
    responseDownloadSettlementPDF: (state) => {
      return {
        ...state,
        isPDFDownload: false,
      };
    },
    failureDownloadSettlementPDF: (state, action) => {
      return { ...state, isPDFDownload: false, isError: action?.payload };
    },

    /////// Generate Bulk Store ////////
    requestGenerateBulkStore: (state) => {
      return { ...state, isGenerating: true };
    },
    responseGenerateBulkStore: (state) => {
      return {
        ...state,
        isGenerating: false,
      };
    },
    failureGenerateBulkStore: (state, action) => {
      return { ...state, isGenerating: false, isError: action?.payload };
    },
  },
});

export const {
  requestGetSettlements,
  failureGetSettlements,
  responseGetSettlements,
  failureDownloadSettlementsPDF,
  requestDownloadSettlementsPDF,
  responseDownloadSettlementsPDF,
  requestSendSettlementsEmail,
  responseSendSettlementsEmail,
  failureSendSettlementsEmail,
  failureDownloadSettlementPDF,
  requestDownloadSettlementPDF,
  responseDownloadSettlementPDF,
  requestGenerateBulkStore,
  responseGenerateBulkStore,
  failureGenerateBulkStore,
  requestGetInvoiceJobs,
  responseGetInvoiceJobs,
  failureGetInvoiceJobs,
} = SettlementsSlice.actions;
export default SettlementsSlice.reducer;
